/**
 * @fileoverview Styles for the SubmitLink component renderer.
 * This module contains styles for a clickable submit link with hover and active states.
 *
 * @example
 * // Usage in component:
 * import styles from './SubmitLinkRenderer.module.css'
 *
 * <button className={styles.link}>Submit</button>
 */


.link {
    color: var(--indigo700);
    max-width: fit-content;
    text-decoration: none;
    cursor: pointer;
    background: none;
    border: none;
    text-decoration: underline;
    text-underline-offset: 3px;

    font-weight: 300;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.017em;
    margin: 0;
    padding: 0;
    outline: none;
    border-radius: 0.75rem;
    transition: all 200ms ease-out;
}

.link:active {
    text-decoration: underline;
}
